<script setup lang="ts">
defineOptions({
    name: 'IdeoFormSelect'
});

const model = defineModel<any>();
const props = withDefaults(defineProps<{
    valueField?: string;
    textField?: string;
    disabledField?: string;
    options?: any[];
    placeholder?: string;
}>(), {
    options: (): any[] => [],
    valueField: 'value',
    textField: 'text',
    disabledField: 'disabled',
    placeholder: undefined
});

const optionValue = (option: Record<string, any>) => option[props.valueField];
const optionText = (option: Record<string, any>) => option[props.textField];
const optionDisabled = (option: Record<string, any>) => option[props.disabledField] ?? false;
</script>

<template>
    <select v-model="model" class="form-select">
        <slot name="first">
            <IdeoFormSelectOption v-if="props.placeholder" :value="null">
                {{ props.placeholder }}
            </IdeoFormSelectOption>
        </slot>
        <slot name="default">
            <IdeoFormSelectOption v-for="(option, i) in options" :key="i" :value="optionValue(option)" :disabled="optionDisabled(option)">
                {{ optionText(option) }}
            </IdeoFormSelectOption>
        </slot>
    </select>
</template>
